import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'

$(document).ready(function(){
  let paddingLeft = $('.section1').css("padding-left")
  let navLeft = $('.section1 .download-types a.active').offset().left - parseInt(paddingLeft.replace('px', ''))
  $('.section1 .download-types').scrollLeft(navLeft)
})